// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
}

:root {
  --primary-color: #004D66;
  --secondary-color: #5B8B9B;
  --tertiary-color :#B4D6E1;
  --white-color: #FFFFFF;
  --black-color: #000000;
  --red-color: #DA342E;
  --gray-color: #676767;
  --white-smoke-color: #EFEFEF;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":["body {\n  margin: 0;\n}\n\n:root {\n  --primary-color: #004D66;\n  --secondary-color: #5B8B9B;\n  --tertiary-color :#B4D6E1;\n  --white-color: #FFFFFF;\n  --black-color: #000000;\n  --red-color: #DA342E;\n  --gray-color: #676767;\n  --white-smoke-color: #EFEFEF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
